import * as React from "react";
const SvgLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#FDFDFD", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M13.5 8h-11M7 3.5 2.5 8 7 12.5" }));
export default SvgLeft;
